import { Box, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

export const HeroSection = Box.withConfig({
  background: 'transparent',
  flexDirection: {
    base: 'column',
    md: 'row',
  },
});

export const ButtonsContainer = Box.withConfig({
  marginTop: {
    base: '$0',
    md: '$6',
  },
  position: {
    base: 'absolute',
  },
  bottom: {
    base: 0,
  },
});

export const ActionButtonStyled = makeUclComponent(ActionButton).withConfig({
  paddingTop: '$3.5',
  paddingBottom: '$3.5',

  _text: {
    fontSize: 'lg',
    lineHeight: 'lg',
  },
});
